import React from "react";
import { cn } from "../utils/style";

function Button({
  type,
  children,
  onClick,
  secondary,
  outline,
  ghost,
  danger,
  className,
  disabled,
  icon: Icon,
}) {
  return (
    <button
      onClick={(e) => {
        if (disabled) return;
        if (type !== "submit") {
          e.preventDefault();
        }
        onClick && onClick(e);
      }}
      type={type || "button"}
      disabled={disabled || false}
      className={cn(
        "group relative flex items-center justify-center gap-2 rounded-xl text-sm px-6 py-2.5 text-center font-bold transition-all duration-300",
        "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500 active:scale-[0.97]",
        {
          // Primary (Default)
          "bg-primary-600 text-white shadow-lg shadow-primary-500/20 hover:bg-primary-500 hover:shadow-primary-500/30":
            !secondary && !outline && !ghost && !danger,
          // Secondary
          "bg-slate-800 text-white shadow-lg shadow-slate-900/10 hover:bg-slate-700 hover:shadow-slate-900/20":
            secondary && !outline && !ghost && !danger,
          // Danger
          "bg-gradient-to-br from-rose-500 to-rose-600 text-white shadow-lg shadow-rose-500/20 hover:from-rose-600 hover:to-rose-700":
            danger,
          // Outline
          "bg-transparent border-2 border-slate-200 text-slate-600 hover:border-primary-500 hover:text-primary-600 hover:bg-primary-50/50":
            outline,
          // Ghost
          "bg-transparent text-slate-500 hover:bg-slate-100 hover:text-slate-900":
            ghost,
          // Disabled
          "opacity-50 cursor-not-allowed grayscale active:scale-100 shadow-none hover:shadow-none":
            disabled,
        },
        className,
      )}
    >
      {Icon && (
        <Icon
          className={cn(
            "h-4 w-4 transition-transform duration-300 group-hover:scale-110",
            { "text-white/80": !outline && !ghost },
          )}
        />
      )}
      <span className="relative z-10">{children}</span>
    </button>
  );
}

export default Button;
